import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_inventory_lot_snapshot_by_projectId_warehouseIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId: number, warehouseId: number, materialId?: number }): 
  Promise<{ result: { TotalPackagedAmount?: number, TotalAmount?: number, TotalGrossWeight?: number, TotalNetWeight?: number, LotId?: number, WarehouseId?: number, PackagedId?: number, WeightUomId?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, LastReceiveDate?: string, Material?: { LookupCode?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_lot_snapshot_by_projectId_warehouseId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId: number, warehouseId: number, materialId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { TotalPackagedAmount?: number, TotalAmount?: number, TotalGrossWeight?: number, TotalNetWeight?: number, LotId?: number, WarehouseId?: number, PackagedId?: number, WeightUomId?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, LastReceiveDate?: string, Material?: { LookupCode?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_lot_snapshot_by_projectId_warehouseId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId: number, warehouseId: number, materialId?: number, $keys: { LotId?: number, WarehouseId?: number, PackagedId?: number, Lot?: { LookupCode?: string, MaterialId?: number, Material?: { LookupCode?: string }, ReceiveDate?: string, LastReceiveDate?: string }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUomId?: number, WeightUom?: { Short_name?: string } }[] }): 
  Promise<{ result: { TotalPackagedAmount?: number, TotalAmount?: number, TotalGrossWeight?: number, TotalNetWeight?: number, LotId?: number, WarehouseId?: number, PackagedId?: number, WeightUomId?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, LastReceiveDate?: string, Material?: { LookupCode?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_lot_snapshot_by_projectId_warehouseId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

